import { render, staticRenderFns } from "./SharedFiles.vue?vue&type=template&id=b777a5dc&"
import script from "./SharedFiles.vue?vue&type=script&lang=js&"
export * from "./SharedFiles.vue?vue&type=script&lang=js&"
import style0 from "./SharedFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports